(function(){
    angular
        .module('app')
        .directive('ngSelect2', ['$timeout', function($timeout){
            return {
                require: 'ngModel',
                restrict: 'A',
                link: function(scope, element, attrs, ngModel) {
                    var $element = $(element);
                    var bloqueado = false;

                    $timeout(function() {
                        var options = {};
                        if (attrs.options) {
                            options = scope.$eval(attrs.options) || {};
                        }

                        // Configuración del Placeholder
                        var placeholderText = $element.find('option[value=""]').text() || "Elige una opcion";
                        
                        $element.select2({
                            placeholder: placeholderText,
                            allowClear: false,
                            width: '100%',
                            ...options
                        });

                        // VISTA -> MODELO
                        $element.on('select2:select', function(e) {
                            var val = e.params.data.id;
                            bloqueado = true; 
                            scope.$evalAsync(function() {
                                ngModel.$setViewValue(val);
                                $timeout(function(){ bloqueado = false; }, 150);
                            });
                        });

                        // MODELO -> VISTA
                        ngModel.$render = function() {
                            if (bloqueado) return;
                            
                            var val = ngModel.$viewValue;
                            // console.log("SELECT2 - RENDER:", val);
                            
                            if (val === null || val === undefined || val === "") {
                                $element.val("").trigger('change.select2');
                                return;
                            }

                            $element.val(val).trigger('change.select2');

                            if (!$element.val() && typeof val === 'string' && val.indexOf('string:') === 0) {
                                $element.val(val.replace('string:', '')).trigger('change.select2');
                            }
                        };
                        
                        scope.$watch(function() { return $element.find('option').length; }, function(newLen, oldLen) {
                            if (newLen !== oldLen) {
                                $timeout(function() {
                                    ngModel.$render();
                                });
                            }
                        });

                        $timeout(function(){
                             ngModel.$render();
                        }, 200);
                    });

                    element.on('$destroy', function() {
                        if ($element.data('select2')) {
                            $element.select2('destroy');
                        }
                    });
                }
            };
        }]);
})();